import React, { useState } from "react";
import { PlanCard } from "../PlanCard";
import { listOfSubscriptions } from "../../../../../common/envConfig";

export const StudioPlans = ({ currentPlan }) => {
  return (
    <div className="flex flex-col md:flex-row gap-5 overflow-x-auto ">
      <PlanCard
        type="Studio"
        header="Coming soon!"
        subText="Perfect for indoor setups"
        textList={[
          "Advanced custom fields",
          "Audit log and data history",
          "Unlimited individual users",
          "Unlimited individual data",
          "Personalized + priority service",
        ]}
        plan={[
          listOfSubscriptions.STUDIO_MASTER,
          listOfSubscriptions.STUDIO_COACH,
        ]}
        currentPlan={currentPlan}
      />
    </div>
  );
};
